(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    const blocks = document.querySelectorAll('.ott-read-more');

    blocks.forEach(block => {
      const showBtn = block.querySelector('.js-show-more');
      const lessBtn = block.querySelector('.js-show-less');

      const setExpanded = (expanded) => {
        block.classList.toggle('ott-read-more-active', expanded);
        showBtn.classList.toggle('hidden', expanded);
        lessBtn.classList.toggle('hidden', !expanded);
        showBtn.setAttribute('aria-expanded', expanded);
      };

      showBtn.addEventListener('click', () => setExpanded(true));
      lessBtn.addEventListener('click', () => setExpanded(false));
    });
  });
})();
